define('app/sdc/datetime/watch/sdc-datetime-watch-factory',["$interval", "$rootScope", "factory!sdc-safe-apply", "moment"], function ($interval, $rootScope, safeApplyFactory, moment) {
	"use strict";
	var apply = safeApplyFactory($rootScope);
	return sdcDatetimeWatchFactory;
	function stringDiff(diff, newDate, oldDate) {
		return newDate.diff(oldDate, diff) !== 0;
	}
	function numberDiff(diff, newDate, oldDate) {
		return newDate.diff(oldDate) > diff;
	}
	function sdcDatetimeWatchFactory(delay, invokeApply, diff, fn) {
		var lastDateTime, promise;
		if (angular.isUndefined(diff)) {
			fn = invokeApply;
			diff = delay;
			invokeApply = undefined;
			delay = undefined;
		}
		else if (angular.isUndefined(fn)) {
			fn = diff;
			diff = invokeApply;
			if (!angular.isNumber(delay)) {
				invokeApply = delay;
				delay = undefined;
			}
		}
		if (angular.isUndefined(delay)) {
			switch (diff) {
				case "hours":
					delay = 2000;
					break;
				case "minutes":
					delay = 1000;
					break;
				case "seconds":
					delay = 500;
					break;
				default:
					delay = 5000
					break;
			}
			delay = moment.duration(delay);
		}
		else {
			delay = moment.duration(delay);
		}
		if (angular.isUndefined(invokeApply)) {
			invokeApply = true;
		}
		if (angular.isString(diff)) {
			diff = stringDiff.bind(null, diff);
		}
		else if (angular.isNumber(diff)) {
			diff = numberDiff.bind(null, diff);
		}
		promise = $interval(watchTimeFn, delay.asMilliseconds(), 0, false);
		return cancelWatch;
		function watchTimeFn() {
			var thisDateTime = moment(),
				hasChanged;
			if (!lastDateTime) {
				lastDateTime = thisDateTime;
				invokeFn(thisDateTime, lastDateTime);
			}
			else if (diff(thisDateTime, lastDateTime)) {
				try {
					invokeFn(thisDateTime, lastDateTime);
				}
				finally {
					lastDateTime = thisDateTime;
				}
			}
		}
		function invokeFn() {
			var context = this,
				args = arguments;
			if (invokeApply) {
				return apply(exec);
			}
			else {
				return exec();
			}
			function exec() {
				return fn.apply(context, args);
			}
		}
		function cancelWatch() {
			$interval.cancel(promise);
		}
	}
});
